import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";

export class UserAccountCancelledEvent extends AmplitudeEvent {
	constructor( emailAddress, reasons = [], comments = "" ) {
		super();
		this.name = "User Account Cancelled";
		this.eventProperties.email_address = emailAddress;
		this.eventProperties.reasons = reasons.map( reason => `${ reason }`.trim() ).join( "," );
		this.eventProperties.comments = comments;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/UserAccountCancelledEvent.js